import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Alert, Box, Button, Col, DataGrid, DatePicker, Paper, Row, Typography } from 'components/AORedesign';
import BackToPaymentManagementButton from '../BackToPaymentManagementButton';
import {
  detailsColumns,
  handleDateOnChange,
  handleOnClickGenerateReport,
} from 'components/AORedesignViews/Reports/BillingReports/PaymentBalance/PaymentBalance.api';
import TotalsTable from 'components/AORedesignViews/Reports/BillingReports/PaymentBalance/TotalsTable';

const BillingServicesReportsPaymentBalance = ({ resetFlow }) => {
  const rawFromDate = moment().subtract(3, 'days');

  const [formData, setFormData] = useState({
    fromDate: moment(rawFromDate).format('MM/DD/yyyy'),
    toDate: moment().format('MM/DD/yyyy'),
  });
  const [reportContentData, setReportContentData] = useState({
    reportDetails: null,
    reportTotals: [],
    isVisible: false,
    loading: false,
    alert: {
      message: null,
      severity: 'info',
      isVisible: false,
    },
  });

  const fromDate = formData.fromDate;
  const toDate = formData.toDate;
  const reportsVisible = reportContentData.isVisible;
  const reportsLoading = reportContentData.loading;
  const detailsData = reportContentData.reportDetails;
  const totalsFromDate = formData.fromDate;
  const totalsToDate = formData.toDate;
  const totalsData = reportContentData.reportTotals;
  const alertSeverity = reportContentData.alert.severity;
  const alertMessage = reportContentData.alert.message;
  const alertVisible = reportContentData.alert.isVisible;

  const handleClickBackToPaymentManagement = () => resetFlow(); // function from parent to reset flow
  const handleOnChangeFromDate = (date) => handleDateOnChange(date, 'fromDate', formData, setFormData);
  const handleOnChangeToDate = (date) => handleDateOnChange(date, 'toDate', formData, setFormData);
  const handleGenerateReport = () => handleOnClickGenerateReport(formData, setReportContentData);

  return (
    <>
      <BackToPaymentManagementButton handleOnClick={handleClickBackToPaymentManagement} />

      <Box id="billing-payment-management-title" mb={2}>
        <Typography variant={'h5'}>Payment Balance Report</Typography>
      </Box>

      <Paper>
        <Box mb={2}>
          <Typography>Select a Date Range for Balancing Report</Typography>
        </Box>
        <Row spacing={2} mb={2}>
          <Col>
            <DatePicker
              label={'Date From'}
              name={'fromDate'}
              minDateMessage={'Must be less than or equal to 31 days.'}
              value={fromDate}
              onChange={handleOnChangeFromDate}></DatePicker>
          </Col>
          <Col>
            <DatePicker
              label={'Date To'}
              name={'toDate'}
              maxDateMessage={'Can not be a future date.'}
              value={toDate}
              onChange={handleOnChangeToDate}></DatePicker>
          </Col>
        </Row>

        <Box mt={2}>
          <Button loading={reportsLoading} onClick={handleGenerateReport}>
            Get Report
          </Button>
        </Box>
      </Paper>

      {alertVisible && <Alert severity={alertSeverity}>{alertMessage}</Alert>}

      {reportsVisible && (
        <>
          <Box my={2}>
            <TotalsTable elevaton={0} fromDate={totalsFromDate} toDate={totalsToDate} rows={totalsData} />
          </Box>
          <Box>
            <DataGrid
              autoHeight
              pageSize={10}
              exportToCSV
              columns={detailsColumns}
              rows={detailsData}
              componentsProps={{ style: { border: '2px solid red' } }}
            />
          </Box>
        </>
      )}
    </>
  );
};
BillingServicesReportsPaymentBalance.propTypes = {
  resetFlow: PropTypes.func, // accept a fn as a prop to go back to parent screen
};

export default BillingServicesReportsPaymentBalance;
